import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "services/api";
import { Industry } from "./types";

export const industriesApi = createApi({
  reducerPath: "industriesService",
  baseQuery,
  endpoints: (builder) => ({
    getIndustryTypes: builder.query<Industry[], null>({
      query: () => "/industry",
    }),
  }),
});

export const { useGetIndustryTypesQuery } = industriesApi;
